import styled from "styled-components";
// hooks
import { Dispatch, SetStateAction, useEffect, useState } from "react";
// utils
import { add, format } from "date-fns";
// context
import { useAdmin } from "../../../context/admin";
// icons
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
// components
import CalendarDual from "../../common/CalendarDual";
// types
import { Ally, Seller } from "../../../types/common.types";
import AdminService from "../../../services/admin.service";
// responsive
import { mobile } from "../../../styles/responsive";

export default function Filter(
    {setSelectedSeller, setSelectedAlly}: 
    {
        setSelectedSeller: Dispatch<SetStateAction<string | undefined>>;
        setSelectedAlly: Dispatch<SetStateAction<string | undefined>>;
    }
    ) {
    const { currentDay, setCurrentDay, endDay, setEndDay, sellerId, allyId } = useAdmin()
    const [sellers, setSellers] = useState<Seller[]>([])
    const [allies, setAllies] = useState<Ally[]>([])
    const [isCalendarOpen, setIsCalendarOpen] = useState(false)

    function handleCurrentDay (action: 'forwards' | 'backwards') {
        const newDate = add(currentDay, {days: action === 'backwards' ? -1 : 1} )
        setCurrentDay(newDate)
    }

    useEffect(() => {
        async function fetchSellers() {
            const data = await (await AdminService.listSellers()).data
            setSellers(data)
        }
        async function fetchAllies() {
            const data = await (await AdminService.listAllies()).data
            setAllies(data)
        }
        fetchSellers()
        fetchAllies()
    }, [])

    function handleSelectSeller (e: React.ChangeEvent<HTMLSelectElement>) {
        const selectedSeller = e.target.value
        if (selectedSeller === '-') return setSelectedSeller(undefined)
        setSelectedSeller(selectedSeller)
    }

    function handleSelectAlly (e: React.ChangeEvent<HTMLSelectElement>) {
        const selectedAlly = e.target.value
        if (selectedAlly === '-') return setSelectedAlly(undefined)
        setSelectedAlly(selectedAlly)
    }
    
    return (
        <Main>
            <button
                onClick={() => handleCurrentDay('backwards')}
                >
                    <IoIosArrowBack/>
                </button>
                <div className="filters">
                    <div className="date"
                    >
                        <button className="open-calendar"
                        onClick={() => setIsCalendarOpen(!isCalendarOpen)}
                        ></button>
                        {
                            currentDay && <span 
                            >{`${format(currentDay, 'dd/MM/yyyy')} ${endDay ? '- ' + format(endDay, 'dd/MM/YYY'): ''}`}</span>
                        }
                        <div className={`calendar ${isCalendarOpen ? 'open' : ''}`}>
                            <CalendarDual
                            endDay={endDay}
                            setEndDay={setEndDay}
                            selectedDay={currentDay}
                            setSelectedDay={setCurrentDay}
                            selectPastDays
                            />
                        </div>
                    </div>
                    <div className="dropdown">
                        <label>Sellers</label>
                        <select
                        value={sellerId}
                        onChange={handleSelectSeller}>
                            <option selected>-</option>
                            <option value="all">Todos</option>
                            {
                                sellers.map(seller => (
                                    <option key={seller.id} value={seller.id}>{seller.name}</option>
                                ))
                            }
                        </select>
                    </div>
                    <div className="dropdown">
                        <label>Allies</label>
                        <select
                        value={allyId}
                        onChange={handleSelectAlly}>
                            <option selected>-</option>
                            <option value="all">Todos</option>
                            {
                                allies.map(ally => (
                                    <option key={ally.id} value={ally.id}>{ally.name}</option>
                                ))
                            }
                        </select>
                    </div>
                </div>
                <button
                onClick={() => handleCurrentDay('forwards')}
                >
                    <IoIosArrowForward/>
                </button>
        </Main>
    )
}

const Main = styled.div`
width: 100%;
padding: 30px 0;
display: flex;
justify-content: space-around;
.filters {
    flex: 1;
    display: flex;
    justify-content: center;
    gap: 10px;
    ${mobile({
        flexDirection: 'column',
        alignItems: 'center'
    })}
}
.filters > .dropdown {
    height: 100%;
    display: flex;
    flex-direction: column;
    select {
        height: 100%;
        padding: 5px 10px;
    }
}
.filters > .date {
    padding: 20px;
    width: 70%;
    max-width: 350px;
    text-align: center;
    height: 100%;
    position: relative;
    z-index: 20;
    > button.open-calendar {
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        background-color: ${props => props.theme.blueLight};
        cursor: pointer;
        border: none;
    }
    > .calendar {
        display: none;
        position: absolute;
        top: 100%;
        left: 50%;
        transform: translateX(-50%);
        &.open {
            display: initial;
        }
    }
    > span {
        color: #FFF;
        position: absolute;
        white-space: nowrap;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        z-index: 10;
    }
}
> button {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 30px;
    border: none;
    background-color: ${props => props.theme.white};
    font-size: 16px;
    color: #000;
    box-shadow: 0 5px 3px ${props => props.theme.blackTransparent};
    transition: transform .3s ease;
    cursor: pointer;
    &:hover {
        transform: translateY(-3px);
    }
}
`